import { IconProps } from '.';

const WorkerIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142909)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.583 14.5C15.9637 14.5 17.083 13.3807 17.083 12C17.083 10.6193 15.9637 9.5 14.583 9.5C13.2023 9.5 12.083 10.6193 12.083 12C12.083 13.3807 13.2023 14.5 14.583 14.5ZM14.583 17C17.3444 17 19.583 14.7614 19.583 12C19.583 9.23858 17.3444 7 14.583 7C11.8216 7 9.58301 9.23858 9.58301 12C9.58301 14.7614 11.8216 17 14.583 17Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5046 21.5887C11.7882 21.6823 9.12697 22.996 7.2066 25.3002L5.28613 23.6996C7.63337 20.8833 10.9468 19.2099 14.4184 19.0901C17.9106 18.9697 21.4703 20.4251 24.2658 23.6864L22.3678 25.3135C21.3772 24.1579 20.293 23.2941 19.1663 22.6904C17.6478 21.8766 16.0522 21.5353 14.5046 21.5887Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.91667 3.25C2.68655 3.25 2.5 3.43655 2.5 3.66667V27C2.5 27.2301 2.68655 27.4167 2.91667 27.4167H10.1574L15 30.5159L19.8426 27.4167H27.0833C27.3135 27.4167 27.5 27.2301 27.5 27V3.66667C27.5 3.43655 27.3135 3.25 27.0833 3.25H2.91667ZM0 3.66667C0 2.05584 1.30584 0.75 2.91667 0.75H27.0833C28.6942 0.75 30 2.05584 30 3.66667V27C30 28.6108 28.6942 29.9167 27.0833 29.9167H20.5741L15 33.4841L9.42591 29.9167H2.91667C1.30584 29.9167 0 28.6108 0 27V3.66667Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142909">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WorkerIcon;
